import { State } from "../state/state";
import Utils from "../../../utils";

export const fromServer = (data: State.BatteryServer): State.Battery => {
  let servDate = new Date(data.ServDate * 1000);
  let instDate = new Date(data.InstDate * 1000);
  return Object.assign({}, data, {
    v: Utils.scaleUx(data.v, 1),
    i: Utils.scaleUx(data.i, 1),
    direct: Utils.numToBool(data.direct),
    Present: Utils.numToBool(data.Present),
    InstDate: `${instDate.toISOString().split("T")[0]}`,
    ServDate: `${servDate.toISOString().split("T")[0]}`,
    Cap: Utils.scaleUx(data.Cap),
    vHigh: Utils.scaleUx(data.vHigh, 1),
    vLow: Utils.scaleUx(data.vLow, 1),
    iHigh: Utils.scaleUx(data.iHigh, 1),
    chg_iHigh: Utils.scaleUx(data.chg_iHigh, 1),
    iLow: Utils.scaleUx(data.iLow, 1),
    chg_iLow: Utils.scaleUx(data.chg_iLow, 1)
  });
};

export const toServer = (
  data: Partial<State.Battery>
): Partial<State.BatteryServer> => {
  let ret: Partial<State.BatteryServer> = {};
  let bools: Partial<State.BatteryServer> = Utils.convertBooleansToNumbers(
    data,
    ["direct", "Present"]
  );
  let server: Partial<State.BatteryServer> = Utils.convertUxToServer(data, [
    "Cap",
    "vHigh",
    "vLow",
    "iHigh",
    "iLow",
    "chg_iHigh",
    "chg_iLow"
  ]);
  if (data.InstDate) ret.InstDate = Date.parse(data.InstDate) / 1000;
  if (data.ServDate) ret.ServDate = Date.parse(data.ServDate) / 1000;
  return Object.assign({}, data, ret, bools, server);
};
